module.exports = __webpack_public_path__ + "img/about_7.53d6ff0d.jpg";